<template>
  <div class="row">
    <img class="contactPhoto" src="/images/nophoto.png">
    <div class="contactNameDiv" />
  </div>
</template>

<script>
export default {
  props: {
    contact: {
      type: Object,
      default: function () {
        return {}
      }
    }
  }
}
</script>

<style scoped>
.row {
  background-color: white;
  margin-bottom: 1px;
  padding: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.contactPhoto {
  width: 50px;
  height: 50px;
  border-radius: 25px;
  object-fit: cover;
}

.contactNameDiv {
  padding-left: 10px;
}
</style>
